import React from 'react';
import { BrowserRouter, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './LanguageContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import TemplatesPage from './pages/TemplatesPage';
import PricingPage from './pages/PricingPage';
import BuilderPage from './pages/BuilderPage';
import CartPage from './pages/CartPage';
import InvitationView from './pages/InvitationView';

function Footer() {
  return (
    <footer className="border-t border-[color:var(--border)] mt-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
        <div>
          <div className="font-serif text-[color:var(--burgundy)] text-lg">Italian Digital Store</div>
          <div className="font-serif italic text-[color:var(--ink-soft)] text-xs">Inviti Digitali Unici</div>
        </div>
        <div className="flex gap-6 text-sm text-[color:var(--ink-soft)]">
          <Link to="/template" className="hover:text-[color:var(--burgundy)]">Template</Link>
          <Link to="/prezzi" className="hover:text-[color:var(--burgundy)]">Prezzi</Link>
          <Link to="/crea" className="hover:text-[color:var(--burgundy)]">Crea il tuo</Link>
          <Link to="/carrello" className="hover:text-[color:var(--burgundy)]">Carrello</Link>
        </div>
        <div className="text-xs text-[color:var(--muted)]">© {new Date().getFullYear()} Italian Digital Store</div>
      </div>
    </footer>
  );
}

function Layout({ children }) {
  const { pathname } = useLocation();
  const isInvite = pathname.startsWith('/invito/');
  if (isInvite) return children;
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen">
      <LanguageProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/template" element={<TemplatesPage />} />
              <Route path="/prezzi" element={<PricingPage />} />
              <Route path="/crea" element={<BuilderPage />} />
              <Route path="/carrello" element={<CartPage />} />
              <Route path="/invito/:id" element={<InvitationView />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
